import { Helmet } from 'react-helmet-async'

const About = () => {
  return (
    <>
      <Helmet>
        <title>About</title>
      </Helmet>
      <h1>About page!</h1>
    </>
  )
}

export default About
